import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Lightning: React.FC<Props> = ({ fill }) => {
    return (
        <Svg
            fill={fill}
            id="Capa_1"
            enable-background="new 0 0 512.002 512.002"
            height="100%"
            viewBox="0 0 512.002 512.002"
            width="12pt"
        >
            <Path d="m201.498 512.002c-1.991 0-4.008-.398-5.934-1.229-6.741-2.907-10.387-10.266-8.617-17.39l50.724-204.178h-136.67c-4.947 0-9.576-2.439-12.373-6.52s-3.401-9.278-1.617-13.892l100.262-259.204c2.235-5.779 7.793-9.589 13.99-9.589h137.962c5.069 0 9.795 2.56 12.565 6.806 2.768 4.246 3.206 9.603 1.162 14.242l-59.369 134.76h117.419c5.486 0 10.534 2.995 13.164 7.809s2.422 10.68-.543 15.296l-209.497 326.193c-2.833 4.412-7.65 6.896-12.628 6.896z" />
        </Svg>
    );
};

export default Lightning;
